var _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgEdit(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M51.696 4.305a7.885 7.885 0 00-11.143 0L5.186 39.673A10.803 10.803 0 002 47.361v4.464A2.175 2.175 0 004.175 54h4.464a10.799 10.799 0 007.687-3.184l35.37-35.37a7.886 7.886 0 000-11.14zM13.25 47.741a6.571 6.571 0 01-4.612 1.91h-2.29v-2.29a6.481 6.481 0 011.912-4.613L35.1 15.907l5.002 5.002L13.251 47.74zm35.368-35.37l-5.45 5.452-5.001-4.991L43.62 7.38a3.532 3.532 0 114.99 5.002l.009-.011z"
  })));
}
export default SvgEdit;